import React, { useMemo } from 'react'

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { mergeDeepRight } from 'ramda'

import { Skeleton } from '@driftt/dds'
import { ChartEmptyState } from '@driftt/dds.reports'

import {
  HeatMapEmptyState,
  OPTIONS,
} from 'components/conversation/ConversationHeatMapChart'

export type HeatMapProps = {
  series: number[][]
  isLoading: boolean
  isEmpty: boolean
  onPointClick: (pointerEvent: Highcharts.PointClickEventObject) => void
}

export const HeatMap = ({
  series,
  isLoading = true,
  isEmpty = false,
  onPointClick,
}: HeatMapProps) => {
  const options: Highcharts.Options = useMemo<Highcharts.Options>(
    () =>
      mergeDeepRight(OPTIONS, {
        series: [
          {
            borderWidth: 3,
            borderColor: '#FFFFFF',
            data: series,
            cursor: 'pointer',
            point: {
              events: {
                click: onPointClick,
              },
            },
          },
        ],
      }) as Highcharts.Options,
    [series, onPointClick]
  )

  return (
    <Skeleton isLoading={isLoading} height={400}>
      {isEmpty ? (
        <ChartEmptyState>
          <HeatMapEmptyState />
        </ChartEmptyState>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </Skeleton>
  )
}
